module.exports = __webpack_public_path__ + "img/icon-interact.c2b10e20.png";